import { render, staticRenderFns } from "./TheRelation.vue?vue&type=template&id=7f8ea16a&"
import script from "./TheRelation.vue?vue&type=script&lang=js&"
export * from "./TheRelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports